import { ChartConfigChartPaneElement } from '../../types/shared'
import { drawingToolsByType } from '../canvas/drawingTools'
import { chartsByType } from '../charts/charts'
import { indicatorsByType } from '../indicators/indicators'
import { overlaysByType } from '../overlays/overlays'

const canvasElements = {
  ...overlaysByType,
  ...indicatorsByType,
  ...drawingToolsByType,
  ...chartsByType,
}

export function getCanvasElementByType(elementType: ChartConfigChartPaneElement['type']) {
  return canvasElements[elementType]
}
